module.exports = __webpack_public_path__ + "static/img/p4.7a4d6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p4.png
// module id = 246
// module chunks = 1